import { render, staticRenderFns } from "./CouponIdList.vue?vue&type=template&id=95b3ef6e&scoped=true&"
import script from "./CouponIdList.vue?vue&type=script&lang=js&"
export * from "./CouponIdList.vue?vue&type=script&lang=js&"
import style0 from "./CouponIdList.vue?vue&type=style&index=0&id=95b3ef6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b3ef6e",
  null
  
)

export default component.exports